// #399 — what a command row says about a firmware upgrade (otaUpdate): the camera answers with
// otaResultReportEvent reports, so the row stays 'sent' (with the progress) until it is done or failed.
import type { G100ConsoleCommand } from '@/types'

export type OtaText = {
  key: 'sent' | 'downloading' | 'done' | 'failed' | 'failedCodeOnly'
  vars: Record<string, string | number>
}

export function otaText(row: G100ConsoleCommand): OtaText | null {
  if (row.action !== 'otaUpdate') return null
  const result = row.result ?? {}
  if (row.state === 'sent') {
    return typeof result.progress === 'number'
      ? { key: 'downloading', vars: { progress: result.progress } }
      : { key: 'sent', vars: {} }
  }
  if (row.state === 'done') return { key: 'done', vars: { version: String(result.version ?? '') } }
  if (row.state === 'failed') {
    const code = row.result_code ?? (result.errorCode as number | undefined) ?? ''
    const message = result.errorMsg
    return typeof message === 'string' && message !== ''
      ? { key: 'failed', vars: { code, message } }
      : { key: 'failedCodeOnly', vars: { code } }
  }
  return null
}
